import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { Fields } from '../../../constants';
import { secretTypeToDefaultValues } from '../../../constants/defaultValues';
import type { SecretFormValues } from '../../../schemas';

export const useResetDefaultValuesOnSecretTypeChange = () => {
    const secretType = useWatch<SecretFormValues, Fields.TYPE>({ name: Fields.TYPE });
    const { reset, getValues } = useFormContext<SecretFormValues>();

    useEffect(() => {
        // The vault is not type-specific, and a prefilled one is not dirty — without carrying it over the
        // reset would silently drop it, both on mount and on every type change.
        reset(
            { ...secretTypeToDefaultValues[secretType], [Fields.VAULT_ID]: getValues(Fields.VAULT_ID) ?? null },
            { keepDirtyValues: true },
        );
    }, [secretType, reset, getValues]);
};
